<div class="language-selection" style="cursor: pointer;" (click)="localeService.toggleTranslation()">
  <div style="margin-top:4px;"><img ngSrc="../../../../assets/img/globe.svg" height="16" width="16"></div>
  <div>{{ localeService.currentLocale }}</div>
</div>
